import React from 'react';
import { Select } from 'antd';
import { PRODUCT_STATUS_OPTIONS, ProductStatusFilterValue } from './productStatusFilterUtils';

interface ProductStatusFilterProps {
  value: ProductStatusFilterValue;
  onChange: (value: ProductStatusFilterValue) => void;
  disabled?: boolean;
}

const ProductStatusFilter: React.FC<ProductStatusFilterProps> = ({ value, onChange, disabled }) => (
  <Select
    value={value}
    onChange={onChange}
    options={PRODUCT_STATUS_OPTIONS}
    disabled={disabled}
    style={{ width: 130 }}
  />
);

export default ProductStatusFilter;